export { default } from "./hero"